import type { BodyMapReport } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'

type UseBodyMapsProps = {
  residentId?: string
}

const useBodyMaps = ({ residentId }: UseBodyMapsProps) => {
  const GET_BODY_MAPS = `/api/list/body-map-reports?resident=${residentId}`

  const { data } = useQuery(
    ['body-maps', residentId],
    () =>
      getJSON({
        url: GET_BODY_MAPS
      }),
    { enabled: !!residentId }
  )

  return {
    bodyMaps: (data?.result || []) as BodyMapReport[]
  }
}

export default useBodyMaps
